import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { Pane } from '../../layers';
import { Heading } from '../../typography';
import { withTheme } from '../../theme';
import MenuOption from './MenuOption';

var MenuOptionsGroup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MenuOptionsGroup, _React$PureComponent);

  function MenuOptionsGroup() {
    _classCallCheck(this, MenuOptionsGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(MenuOptionsGroup).apply(this, arguments));
  }

  _createClass(MenuOptionsGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          options = _this$props.options,
          selected = _this$props.selected,
          onChange = _this$props.onChange;
      return React.createElement(Pane, {
        paddingY: 8
      }, title && React.createElement(Heading, {
        size: 100,
        marginLeft: 44,
        marginRight: 16,
        marginY: 8
      }, title), React.createElement(Pane, null, options.map(function (option) {
        return React.createElement(MenuOption, {
          key: option.value,
          isSelected: option.value === selected,
          onSelect: function onSelect() {
            return onChange(option.value);
          }
        }, option.label);
      })));
    }
  }]);

  return MenuOptionsGroup;
}(React.PureComponent);

MenuOptionsGroup.displayName = "MenuOptionsGroup";

_defineProperty(MenuOptionsGroup, "propTypes", {
  /**
   * Title of the menu group.
   */
  title: PropTypes.node,

  /**
   * The current value of the option group.
   */
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Function called when selection changes.
   */
  onChange: PropTypes.func,

  /**
   * List of options rendered in the group.
   */
  options: PropTypes.array
});

export default withTheme(MenuOptionsGroup);